import { Base } from "ui/Scripts/source/framework/base";
import React, { ReactNode } from "react";
import { AppSettingsIcon } from "source/components/framework/Icon/AppSettingsIcon";

export interface IPagePanel {
    id: string; //Used only for task charts
    title: string; //Used only for task charts
    panelType: number;
    size: number;
    position: number;
    visible: boolean;
    showInFrontPage: boolean;

    getIcon(props?: any): ReactNode;
    getTitle(): string;
    getId(): string;
    getUniqueId(): string;
    getDisabled(): boolean;
}

export class PagePanel implements IPagePanel {
    id: string;
    title: string;
    panelType: number;
    size: number;
    position: number;
    visible: boolean;
    showInFrontPage: boolean;

    constructor();
    constructor(obj: IPagePanel);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.title = obj && obj.title || "";
        this.panelType = obj && obj.panelType || 0;
        this.size = obj && obj.size || 0;
        this.position = obj && obj.position || 0;
        this.visible = obj && obj.visible || false;
        this.showInFrontPage = obj && obj.showInFrontPage || false;
    }

    getIcon(props?: any): ReactNode {
        return React.createElement(AppSettingsIcon, props);
    }

    getTitle(): string {
        return this.panelType.toString(10);
    }

    getId(): string {
        return this.id || this.panelType.toString(10);
    }

    getUniqueId(): string {
        return this.id || this.panelType.toString(10);
    }

    getDisabled(): boolean {
        return false;
    }

    static swapPagePanels(list: IPagePanel[], startIndex, endIndex) {
        const result = list.slice(0);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };
    
    static sortPagePanels(items: IPagePanel[]): IPagePanel[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IPagePanel, b: IPagePanel) => {
            if (!a || !b) return 0;
            return Base.numCompare(a.position, b.position);
        });
    }
}